import { User } from '@interfaces';

export enum DataListingRequestStatus {
  WAITING = 'WAITING',
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
}

export interface DataListingRequest {
  id: string;

  status: DataListingRequestStatus;

  requestedBy: User;
  requestedById: string;
  requestedAt: Date;

  fulfilledBy: User;
  fulfilledById: string;
  fulfilledAt: Date;
}
